module.exports = __webpack_public_path__ + "assets/img/pegi-fr.4a57ec18.png";